export default __webpack_public_path__ + "static/media/logo.ec3fd32b.png";